/* Kolab product page:
   1. Payment icons act as "buy now" buttons: add the selected variant to the cart, then go to checkout.
   2. Lazy-load the Kolab Culture clips when visible and offer a pause control. */
(function () {
  if (window.__kolabPdpA) return; window.__kolabPdpA = true;
  /* ---------- 1. Payment icons → checkout ---------- */
  var payments = document.querySelector('.kolab-payments');
  if (payments) {
    var caption = payments.querySelector('[data-kolab-caption]');
    var busy = false;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function say(key) {
      if (caption) caption.textContent = caption.dataset[key] || caption.dataset['default'];
    }
    function variantInput() {
      var form = document.querySelector('product-info.kolab-pdp form[data-type="add-to-cart-form"]');
      return form ? form.querySelector('input[name="id"]') : null;
    }

    payments.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-kolab-checkout]');
      if (!btn || busy) return;
      var input = variantInput();
      if (!input || !input.value || input.disabled) {
        say('nosize');
        var picker = document.querySelector('product-info.kolab-pdp .variant-picker');
        if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      busy = true;
      payments.classList.add('is-busy');
      say('loading');
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(input.value), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = root + 'checkout';
      }).catch(function () {
        busy = false;
        payments.classList.remove('is-busy');
        say('error');
        setTimeout(function () { say('default'); }, 4000);
      });
    });
  }

  /* ---------- 1b. Gallery: photo grid under the thumbnails + "01 / 05 · View 01" counter ---------- */
  var gallery = document.querySelector('product-info.kolab-pdp media-gallery');
  if (gallery) {
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.product__media-item'));
    var thumbs = gallery.querySelector('slider-thumbnails');
    if (slides.length > 1 && thumbs && !gallery.querySelector('.kolab-photo-grid')) {
      var grid = document.createElement('div');
      grid.className = 'kolab-photo-grid';
      slides.slice(1).forEach(function (slide, i) {
        var img = slide.querySelector('img');
        if (!img) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', img.alt + '. ' + (i + 2));
        var copy = document.createElement('img');
        copy.src = img.currentSrc || img.src;
        copy.alt = img.alt;
        copy.loading = 'lazy';
        b.appendChild(copy);
        b.addEventListener('click', function () {
          var thumb = gallery.querySelector('[thumbs-slide][data-media-position="' + (i + 2) + '"] button');
          if (thumb) thumb.click();
          gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        grid.appendChild(b);
      });
      thumbs.insertAdjacentElement('afterend', grid);
    }

    var counter = gallery.querySelector('[control-numbers]');
    if (counter) {
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var fmt = function () {
        var m = counter.textContent.match(/(\d+)\s*\/\s*(\d+)/);
        if (!m) return;
        var cur = Number(m[1]), tot = Math.max(Number(m[2]), slides.length);
        var txt = pad(cur) + ' / ' + pad(tot) + ' · View ' + pad(cur);
        if (counter.textContent !== txt) counter.textContent = txt;
      };
      fmt();
      new MutationObserver(fmt).observe(counter, { childList: true, characterData: true, subtree: true });
    }
  }

  /* ---------- 2. Kolab Culture clips ---------- */
  var culture = document.querySelector('.kolab-culture');
  if (!culture) return;

  var videos = Array.prototype.slice.call(culture.querySelectorAll('video[data-src]'));
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var paused = reduceMotion;

  function load(video) {
    if (video.dataset.loaded) return;
    video.src = video.dataset.src;
    video.dataset.loaded = '1';
  }
  function play(video) {
    if (paused) return;
    load(video);
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) play(entry.target); else entry.target.pause();
      });
    }, { threshold: 0.35 });
    videos.forEach(function (v) { io.observe(v); });
  } else {
    videos.forEach(play);
  }

  var toggle = culture.querySelector('.kolab-culture-toggle');
  culture.dataset.paused = paused ? 'true' : 'false';
  if (toggle) {
    toggle.addEventListener('click', function () {
      paused = !paused;
      culture.dataset.paused = paused ? 'true' : 'false';
      toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
      videos.forEach(function (v) { paused ? v.pause() : play(v); });
    });
  }
})();

/* ---------- 3. Sticky purchase bar, brand dialog, wishlist, clip viewer ---------- */
(function () {
  if (window.__kolabPdpB) return; window.__kolabPdpB = true;
  var info = document.querySelector('product-info.kolab-pdp');
  if (!info) return;

  function atcButton() {
    var form = info.querySelector('form[data-type="add-to-cart-form"]');
    return form ? form.querySelector('button[type="submit"], [name="add"]') : null;
  }
  function variantInput() {
    var form = info.querySelector('form[data-type="add-to-cart-form"]');
    return form ? form.querySelector('input[name="id"]') : null;
  }
  function openDialog(d) {
    if (!d) return;
    if (d.showModal) d.showModal(); else d.setAttribute('open', '');
    document.documentElement.classList.add('kolab-dialog-open');
  }
  function closeDialog(d) {
    if (!d) return;
    if (d.close) d.close(); else d.removeAttribute('open');
    document.documentElement.classList.remove('kolab-dialog-open');
  }
  document.addEventListener('click', function (e) {
    var close = e.target.closest('[data-kolab-dialog-close]');
    if (close) closeDialog(close.closest('dialog'));
  });
  document.querySelectorAll('.kolab-dialog').forEach(function (d) {
    d.addEventListener('click', function (e) {
      if (e.target !== d) return;
      var r = d.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeDialog(d);
    });
    d.addEventListener('close', function () { document.documentElement.classList.remove('kolab-dialog-open'); });
  });

  /* --- Sticky purchase bar, with its own size picker --- */
  var sticky = document.querySelector('[data-kolab-sticky]');
  if (sticky) {
    var stickyBuy = sticky.querySelector('[data-kolab-sticky-buy]');
    var stickyPrice = sticky.querySelector('[data-kolab-sticky-price]');
    var sizeWrap = sticky.querySelector('[data-kolab-sticky-sizes]');
    /* The theme pre-checks the first size. That is not a customer decision, so the bar
       stays in "choose your size" until the shopper picks one here or in the main picker. */
    var chosen = false;

    function picker() { return document.querySelector('product-info.kolab-pdp .variant-picker'); }
    function radios() {
      var vp = picker();
      if (!vp) return [];
      /* Mid re-render the theme can hold the old and the new options at once,
         so keep the first input per value. */
      var seen = {}, out = [];
      Array.prototype.forEach.call(vp.querySelectorAll('input[type="radio"]'), function (i) {
        if (seen[i.value]) return;
        seen[i.value] = 1;
        out.push(i);
      });
      return out;
    }
    function soldOut(input) { return input.disabled || input.classList.contains('disabled'); }
    function livePrice() { return document.querySelector('product-info.kolab-pdp .price'); }

    function buildSizes() {
      var list = radios();
      while (sizeWrap.firstChild) sizeWrap.removeChild(sizeWrap.firstChild);
      if (!list.length) { sizeWrap.hidden = true; chosen = true; return; }
      sizeWrap.hidden = false;
      list.forEach(function (input) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'kolab-sticky-size';
        chip.textContent = input.value;
        chip.dataset.value = input.value;
        if (soldOut(input)) {
          chip.classList.add('is-soldout');
          chip.setAttribute('aria-label', input.value + '. Sold out');
        }
        chip.setAttribute('aria-pressed', String(chosen && input.checked));
        chip.addEventListener('click', function () {
          if (soldOut(input)) return;
          var vp = picker();
          var label = vp && vp.querySelector('label[for="' + input.id + '"]');
          if (label) label.click(); else { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
          chosen = true;
          sticky.classList.remove('needs-size');
          setTimeout(function () { buildSizes(); refresh(); }, 120);
          setTimeout(function () { buildSizes(); refresh(); }, 600);
        });
        sizeWrap.appendChild(chip);
      });
    }

    function refresh() {
      var list = radios();
      var current = list.filter(function (i) { return i.checked; })[0];
      var unavailable = current ? soldOut(current) : false;
      if (!list.length) chosen = true;
      stickyBuy.textContent = unavailable ? stickyBuy.dataset.sold
        : (chosen ? stickyBuy.dataset.add : stickyBuy.dataset.choose);
      stickyBuy.disabled = unavailable;
      stickyBuy.classList.toggle('is-ready', chosen && !unavailable);
      var lp = livePrice();
      if (lp && stickyPrice) {
        var txt = (lp.textContent || '').trim().split('\n')[0].trim();
        if (txt) stickyPrice.textContent = txt;
      }
      Array.prototype.forEach.call(sizeWrap.querySelectorAll('.kolab-sticky-size'), function (chip) {
        chip.setAttribute('aria-pressed', String(chosen && current && chip.dataset.value === current.value));
      });
    }

    stickyBuy.addEventListener('click', function () {
      if (!chosen) {
        sticky.classList.add('needs-size');
        sizeWrap.scrollIntoView({ block: 'nearest', inline: 'start' });
        setTimeout(function () { sticky.classList.remove('needs-size'); }, 1600);
        return;
      }
      var form = document.querySelector('product-info.kolab-pdp form[data-type="add-to-cart-form"]');
      var real = form && form.querySelector('button[type="submit"], [name="add"]');
      if (real) real.click();
    });

    /* A size chosen in the main picker counts as a real choice too. */
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('.variant-picker input[type="radio"]')) {
        chosen = true;
        setTimeout(function () { buildSizes(); refresh(); }, 120);
      }
    });

    buildSizes();
    refresh();

    /* The theme re-renders the picker and price on variant change; rebuild from the new DOM.
       The bar lives inside product-info, so ignore our own mutations or we loop forever. */
    var host = document.querySelector('product-info.kolab-pdp');
    if (host) {
      var rebuilding = false, queued = false;
      new MutationObserver(function (records) {
        if (rebuilding) return;
        var relevant = records.some(function (r) {
          var n = r.target;
          return n && n.nodeType === 1 && !n.closest('.kolab-sticky') && !n.closest('.kolab-dialog');
        });
        if (!relevant || queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false; rebuilding = true;
          buildSizes(); refresh();
          requestAnimationFrame(function () { rebuilding = false; });
        });
      }).observe(host, { childList: true, subtree: true });
    }

    var anchor = (function () {
      var form = document.querySelector('product-info.kolab-pdp form[data-type="add-to-cart-form"]');
      return form ? form.querySelector('button[type="submit"], [name="add"]') : null;
    })();
    if (anchor && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      /* Other floating widgets (the theme's back-to-top, the loyalty app button) live in the
         bottom-right corner, right on top of the buy button. Lift them while the bar shows. */
      function markBar(on) {
        document.documentElement.classList.toggle('kolab-sticky-on', on);
        var h = Math.round(sticky.getBoundingClientRect().height) || 60;
        if (on) document.documentElement.style.setProperty('--kolab-sticky-h', h + 'px');
        /* The theme's back-to-top ignores stylesheet overrides (our CSS loads before the
           theme's), so move it from script, which nothing else competes with. */
        var btt = document.querySelector('back-to-top');
        if (btt) {
          if (on) btt.style.setProperty('margin-block-end', (h + 12) + 'px', 'important');
          else btt.style.removeProperty('margin-block-end');
        }
      }
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        markBar(show);
      }, { threshold: 0 }).observe(anchor);
      window.addEventListener('resize', function () {
        if (sticky.classList.contains('is-visible')) markBar(true);
      });
    }
  }

  /* --- Brand dialog --- */
  var brandDialog = document.querySelector('[data-kolab-brand-dialog]');
  var brandLink = info.querySelector('[data-kolab-brand-open]');
  if (brandDialog && brandLink) {
    brandLink.classList.add('has-dialog');
    brandLink.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      openDialog(brandDialog);
    });
  }

  /* --- Wishlist heart, saved in this browser --- */
  var gallery = info.querySelector('.etheryx-product-media media-gallery');
  var handle = info.dataset.kolabHandle;
  var PT_LOCALE = document.documentElement.lang && document.documentElement.lang.indexOf('pt') === 0;
  var WISH_URL = '/pages/wishlist';
  var WISH_SAVED = PT_LOCALE ? 'Guardado' : 'Saved';
  var WISH_REMOVED = PT_LOCALE ? 'Removido' : 'Removed';
  var WISH_VIEW = PT_LOCALE ? 'Ver lista' : 'View list';
  if (gallery && handle && !info.querySelector('.kolab-wish')) {
    var KEY = 'kolab:wishlist';
    function read() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
    function write(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }

    var heart = document.createElement('button');
    heart.type = 'button';
    heart.className = 'kolab-wish';
    heart.innerHTML = '<span class="kolab-wish-icon" aria-hidden="true">♡</span>';
    var saved = !!read()[handle];
    function paint() {
      heart.setAttribute('aria-pressed', String(saved));
      heart.querySelector('.kolab-wish-icon').textContent = saved ? '♥' : '♡';
      heart.setAttribute('aria-label', saved ? 'Remove from saved items' : 'Save this item');
      heart.title = heart.getAttribute('aria-label');
    }

    /* Ask for an email every time a logged-out visitor saves something.
       Only people who already subscribed here, or who are logged in, are left alone. */
    var ASK_DONE = 'kolab:wish-subscribed';
    var ask = document.querySelector('[data-kolab-wishask]');

    function askAllowed() {
      if (!ask) return false;
      if (ask.dataset.loggedIn === 'true') return false;
      try { if (localStorage.getItem(ASK_DONE)) return false; } catch (e) {}
      return true;
    }
    function maybeAsk() {
      if (!askAllowed()) return false;
      var body = ask.querySelector('[data-kolab-wishask-body]');
      var done = ask.querySelector('[data-kolab-wishask-done]');
      var err = ask.querySelector('[data-kolab-wishask-error]');
      if (body) body.hidden = false;
      if (done) done.hidden = true;
      if (err) err.hidden = true;
      var submitBtn = ask.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.disabled = false;
      ask.hidden = false;
      void ask.offsetWidth; /* force layout so the transition runs; rAF never fires in a background tab */
      ask.classList.add('is-on');
      var field = ask.querySelector('input[type="email"]');
      if (field) setTimeout(function () { field.focus(); }, 260);
      return true;
    }
    function closeAsk() {
      if (!ask) return;
      ask.classList.remove('is-on');
      setTimeout(function () { ask.hidden = true; }, 220);
    }

    if (ask) {
      var askClose = ask.querySelector('[data-kolab-wishask-close]');
      if (askClose) askClose.addEventListener('click', function () { closeAsk(); });

      var askForm = ask.querySelector('form');
      if (askForm) {
        askForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var body = ask.querySelector('[data-kolab-wishask-body]');
          var done = ask.querySelector('[data-kolab-wishask-done]');
          var err = ask.querySelector('[data-kolab-wishask-error]');
          var submit = askForm.querySelector('button[type="submit"]');
          err.hidden = true;
          if (submit) submit.disabled = true;
          fetch(askForm.action, { method: 'POST', body: new FormData(askForm), headers: { 'Accept': 'text/html' } })
            .then(function (r) {
              if (r.url && r.url.indexOf('customer_posted=true') > -1) {
                try { localStorage.setItem(ASK_DONE, '1'); } catch (e) {}
                body.hidden = true;
                done.hidden = false;
                setTimeout(function () { closeAsk(); }, 2600);
              } else {
                throw new Error('not accepted');
              }
            })
            .catch(function () {
              err.hidden = false;
              if (submit) submit.disabled = false;
            });
        });
      }
    }

    /* Small confirmation with a way through to the saved-items page. */
    var flash = document.createElement('div');
    flash.className = 'kolab-wish-flash';
    flash.hidden = true;
    var flashTimer;
    function sayFlash(html) {
      flash.innerHTML = html;
      flash.hidden = false;
      clearTimeout(flashTimer);
      flash.classList.add('is-on');
      flashTimer = setTimeout(function () {
        flash.classList.remove('is-on');
        setTimeout(function () { flash.hidden = true; }, 220);
      }, 4200);
    }

    heart.addEventListener('click', function () {
      var all = read();
      saved = !saved;
      if (saved) all[handle] = { title: info.dataset.kolabTitle, url: info.dataset.kolabUrl, at: Date.now() };
      else delete all[handle];
      write(all);
      document.dispatchEvent(new CustomEvent('kolab:wishlist-changed'));
      paint();
      heart.classList.remove('just-saved');
      void heart.offsetWidth;
      if (saved) {
        heart.classList.add('just-saved');
        if (!maybeAsk()) sayFlash('<span>' + WISH_SAVED + '</span><a href="' + WISH_URL + '">' + WISH_VIEW + ' &rarr;</a>');
      } else {
        sayFlash('<span>' + WISH_REMOVED + '</span>');
      }
    });
    paint();
    gallery.appendChild(heart);
    gallery.appendChild(flash);
    if (ask) gallery.appendChild(ask);
    gallery.classList.add('has-wish');
  }

  /* --- Clip viewer --- */
  var clipDialog = document.querySelector('[data-kolab-clip-dialog]');
  if (clipDialog) {
    var big = clipDialog.querySelector('video');
    var caption = clipDialog.querySelector('.kolab-dialog-caption');
    document.querySelectorAll('[data-kolab-clip]').forEach(function (clip) {
      clip.addEventListener('click', function () {
        var v = clip.querySelector('video');
        big.poster = v.getAttribute('poster') || '';
        big.src = v.getAttribute('src') || v.dataset.src;
        big.muted = true;
        caption.textContent = (clip.querySelector('span') || {}).textContent || '';
        openDialog(clipDialog);
        var p = big.play();
        if (p && p.catch) p.catch(function () {});
      });
    });
    clipDialog.addEventListener('close', function () { big.pause(); });
  }
})();
